import { CurrentSlipVm, EngineReportDetails } from '@navstation-portal/reporting/data-model/engine-report';
import { Units } from '@navstation-portal/shared/data-model/ui';
import { getHardValidation } from '../range-tooltip.utils';

const PROPELLER_SLIP_LIMITS = { min: -100, max: 100 } as const;

export function buildCurrentSlipVm(details: EngineReportDetails | undefined): CurrentSlipVm {
  const propellerSlipValidation = getHardValidation(
    details?.propellerSlip,
    PROPELLER_SLIP_LIMITS,
    'Propeller Slip',
    Units.percent
  );

  return {
    propellerSlipInvalid: propellerSlipValidation.invalid,
    propellerSlipInvalidTooltip: propellerSlipValidation.tooltip,
  };
}
